import "../components/plasmic/nebank/plasmic.css"; // plasmic-import: tduzggWPyptPHtemkm2DXC/projectcss
import "@/styles/globals.css";
import "survey-core/survey-core.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {faviconLinks, resolveThemeSlug} from "@/components/theme";
import {useSystemTheme} from "@/hooks/useSystemTheme";
import {
    AnalyticsProvider,
    GoogleTag,
    LGRuntimeProvider,
    SeznamCounter,
    useRuntimeConfig,
} from "@lg-plus/landing-components";
import {PlasmicRootProvider} from "@plasmicapp/react-web";
import type {AppProps} from "next/app";
import Head from "next/head";
import Link from "next/link";

export default function MyApp({Component, pageProps}: AppProps) {
    const config = useRuntimeConfig(pageProps);
    const themeSlug = resolveThemeSlug(pageProps.traits);
    const isDarkMode = useSystemTheme();
    const extendedProps = {
        ...pageProps,
        traits: {
            ...pageProps.traits,
            isDarkMode,
        },
    };
    return (
        <PlasmicRootProvider Head={Head} Link={Link}>
            <Head>
                {faviconLinks(themeSlug)}
                <meta property="og:image:width" content="512" />
                <meta property="og:image:height" content="512" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="NBN půjčka" />
                <meta property="og:description" content="Schválení půjčky do 15 minut." />
            </Head>
            <AnalyticsProvider config={config}>
                <GoogleTag gtmId={config.gtmId} gtmCustomParams={config.gtmCustomParams} />
                <SeznamCounter rtgId={config.seznamRtgId} />
                <LGRuntimeProvider
                    config={config}
                    initialCommand={pageProps.initialCommand}
                    initialFormData={pageProps.initialFormData}
                    flashMessage={pageProps.flashMessage}
                >
                    <Component {...extendedProps} />
                </LGRuntimeProvider>
            </AnalyticsProvider>
        </PlasmicRootProvider>
    );
}
